import {
  assertNotNullObject,
  assertNumberArray,
} from 'helpers/utils/checkType';

const getFullRegion = ({
  name,
  region,
  country,
}: {
  name: string;
  region: string;
  country: string;
}): string => {
  return `${name}, ${region}, ${country}`;
};

const replaceNullsWithEmptyArray = (obj: object): Record<string, any> => {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    return {
      ...acc,
      [key]: value === null ? [] : value,
    };
  }, {});
};

const replaceNumberArraysWithStringArrays = (obj: Record<string, any>) => {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    return {
      ...acc,
      [key]: assertNumberArray(value) ? value.map((v) => `${v}`) : value,
    };
  }, {});
};

export const deserializeFilters = (filters: any) => {
  if (!assertNotNullObject(filters)) {
    throw new Error('Filters must be a not null object');
  }

  return {
    ...replaceNumberArraysWithStringArrays(replaceNullsWithEmptyArray(filters)),
    city: {
      label: getFullRegion({
        name: (filters as { city: any }).city.name,
        region: (filters as { city: any }).city.region,
        country: (filters as { city: any }).city.country,
      }),
      value: (filters as { city: any }).city.id,
    },
  };
};
